<template>
  <div
    class="w-full flex flex-col gap-4 text-white"
    :class="{
      'border border-gray-4 border-opacity-20 p-3 lg:p-5 rounded-3xl':
        hasBorder,
    }"
  >
    <div v-if="title" class="flex items-center justify-between">
      <h1 class="text-lg lg:text-2xl font-bold">{{ title }}</h1>
      <slot name="action" />
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "SectionRow",
  props: {
    title: String,
    hasBorder: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
